import { toArenaGlobalId } from "#common/globalId";
import type { Space } from "#common/types/vault";

export type ScopedSpaceClient = {
  bareId: string;
  name: string;
  globalId: string;
  /**
   * False when `clientNames` had no entry for this id. `clientArenas` can be
   * shorter than `clients` (an unresolved federation entity is dropped, not
   * nulled), so the name is unknown rather than absent — the picker must not
   * offer it as a normal, pickable option labelled with a raw pk.
   */
  resolved: boolean;
};

/**
 * The upload Client picker options when a space is scoped to specific clients,
 * ordered by display name. Returns `null` for all-clients spaces and when scope
 * is unknown (drafts/mocks), so callers keep the unscoped `ClientSearch` path.
 */
export function scopedSpaceClients(space?: Space): ScopedSpaceClient[] | null {
  if (!space || space.appliesToAllClients !== false) return null;
  return (space.clients ?? [])
    .map((bareId) => {
      const name = space.clientNames?.[bareId];
      return {
        bareId,
        name: name ?? `Client ${bareId} (unavailable)`,
        globalId: toArenaGlobalId(bareId),
        resolved: name !== undefined,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}
